module.exports = __webpack_public_path__ + "img/logo.51a30d13.png";